import React, { ReactNode } from 'react';
import * as S from './styles';

interface Props {
  children: ReactNode;
  collapsed: boolean;
  expandText: string;
  onExpand: () => void;
}

const Collapsible = ({ children, collapsed, expandText, onExpand }: Props) => (
  <S.CollapsibleWrapper collapsed={collapsed}>
    {children}
    {collapsed && (
      <S.ExpandButton onClick={onExpand}>{expandText}</S.ExpandButton>
    )}
  </S.CollapsibleWrapper>
);

export default Collapsible;
